import styled from '@emotion/styled';
import { Swatches, ThemeLight } from '../base/variables';

export const AvatarStackContainer = styled.div`
    display: inline-flex;
    position: relative;
    height: 32px;
    vertical-align: middle;
`;

export const AvatarWrapper = styled.div<{ index: number }>`
    position: absolute;
    left: ${props => props.index * 17}px;
    width: 32px;
    height: 32px;
    z-index: ${props => props.index};
`;

export const Avatar = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 9999px;
    background: ${ThemeLight.PrimaryInverted9};
    border: 2px solid ${Swatches.White};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${ThemeLight.PrimaryInverted2};
    font-size: 12px;
    cursor: default;
`;

export const EmptyState = styled.span`
    color: ${Swatches.Gray7};
    font-style: italic;
    font-size: 12px;
`;

